import React, { useEffect, useState,Suspense, lazy } from 'react'
import Image from "../components/elements/Image"
import siteLogo from "../assets/images/logo.png"
import Button from "../components/form/Button"
import { useParams } from 'react-router-dom'
import { apiRequest } from '../util/apiUtils'
//const QRScanner = lazy(() => import('../components/QRScanner'));

const Home = () => {  
  const params = useParams();
  const tableNumber = params?.table;
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [showScanner, setShowScanner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);
      try {
        const result = await apiRequest("post", `order/order-detail`, {
          body: { tableNumber },
        });
        if (result.status === 200) {
          const orderData = result?.data?.data || {};
          const billAmount = orderData?.billAmount || 0;
          const paidAmount = Array.isArray(orderData?.miniStatement)
            ? orderData.miniStatement.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
            : 0;
          const remaining = billAmount - paidAmount;          
          setRemainingAmount(remaining);         
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [tableNumber]);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="max-w-96 w-full mx-auto px-5">
        <div className="w-52 aspect-square overflow-hidden mx-auto">
          <Image src={siteLogo} classes={'object-cover'} />
        </div>
        <div className="space-y-3 mt-20">
          <Button
            buttonLabel={'View Menu'}
            buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
            buttonClasses={"bg-black hover:bg-buttonPrimary rounded-[10px] w-full h-12"}
            buttonHasLink={true}
            buttonLink={(tableNumber && tableNumber !== undefined)?`/bistro/menu/table/${tableNumber}`:`/bistro/menu`}
          />
          {/* <Button
            buttonLabel="Scan QR Code"
            buttonFunction={() => setShowScanner(true)}
          />

          {showScanner && (
            <Suspense fallback={<div>Loading scanner...</div>}>
              <QRScanner onClose={() => setShowScanner(false)} />
            </Suspense>
          )} */}
          {/* <Button
            buttonLabel={'Bill Pay'}
            buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
            buttonClasses={"bg-buttonPrimary rounded-[10px] w-full h-12"}
            buttonHasLink={true}
            buttonLink={"/bistro/bill/table/1"}
          /> */}

          {typeof remainingAmount === "number" && remainingAmount > 0 && (
            <Button
              buttonLabel={`Pay Now $${remainingAmount.toFixed(2)}`}
              buttonLabelClasses="font-Roboto font-semibold text-lg capitalize"
              buttonClasses="bg-black hover:bg-buttonPrimary rounded-[10px] w-full h-12"
              buttonHasLink
              buttonLink={`/bistro/paybill/table/${tableNumber}`} // ✅ dynamic table link
            />
          )}          
        </div>
      </div>
    </div>
  )
}

export default Home